(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mw-outlet"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.mwReady) return;
    root.dataset.mwReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-mw-card]'));
    const filters = root.querySelector('.mw-filters');
    const count = root.querySelector('[data-mw-count]');
    const updateCount = () => { if (count) count.textContent = String(cards.filter(card => !card.hidden).length) + ' / ' + cards.length; };
    if (filters && cards.length) {
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-mw-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = button.dataset.mwFilter !== 'all' && card.dataset.power !== button.dataset.mwFilter; });
        updateCount();
      });
      updateCount();
    }
    root.querySelectorAll('[data-mw-variant]').forEach(select => {
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const card = select.closest('[data-mw-card]');
        card.querySelector('[data-mw-price]').textContent = option.dataset.price;
        card.querySelector('[data-mw-compare-price]').textContent = option.dataset.compare;
        card.querySelector('[data-mw-compare]').hidden = !option.dataset.compare;
        const saving = card.querySelector('[data-mw-saving]');
        saving.textContent = option.dataset.saving;
        saving.hidden = !option.dataset.compare;
        card.querySelectorAll('[data-mw-product-link]').forEach(link => { link.href = option.dataset.url; });
      });
    });
    const sticky = root.querySelector('[data-mw-sticky]');
    const hero = root.querySelector('.mw-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      });
      observer.observe(hero);
      root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
  }
  const initAll = () => document.querySelectorAll('.mw-outlet').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
